// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"372":"47a46570","389":"127c5a9c","987":"a175da3d"}[chunkId] + ".js";
};